import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/public/Home";
import Services from "@/pages/public/Services";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import Flights from "@/pages/public/Flights";

import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import AdminCustomers from "@/pages/admin/Customers";
import AdminServices from "@/pages/admin/Services";
import AdminInvoices from "@/pages/admin/Invoices";
import AdminSubscribers from "@/pages/admin/Subscribers";
import AdminContactInbox from "@/pages/admin/ContactInbox";
import AdminAudit from "@/pages/admin/AuditLog";
import AdminSettings from "@/pages/admin/Settings";

import InvoicePay from "@/pages/InvoicePay";
import PayHub from "@/pages/public/PayHub";
import PaySuccess from "@/pages/public/PaySuccess";
import AdminCustomPayments from "@/pages/admin/CustomPayments";

const Public = (El) => (
  <PublicLayout>
    <El />
  </PublicLayout>
);

const Protected = (El) => (
  <ProtectedRoute>
    <El />
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site */}
            <Route path="/" element={Public(Home)} />
            <Route path="/flights" element={Public(Flights)} />
            <Route path="/services" element={Public(Services)} />
            <Route path="/about" element={Public(About)} />
            <Route path="/contact" element={Public(Contact)} />

            {/* Invoice payment (public link) */}
            <Route path="/pay" element={<PayHub />} />
            <Route path="/pay/success" element={<PaySuccess />} />
            <Route path="/pay/:token" element={<InvoicePay />} />
            <Route path="/pay/:token/success" element={<InvoicePay />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={Protected(Dashboard)} />
            <Route path="/admin/customers" element={Protected(AdminCustomers)} />
            <Route path="/admin/services" element={Protected(AdminServices)} />
            <Route path="/admin/invoices" element={Protected(AdminInvoices)} />
            <Route path="/admin/subscribers" element={Protected(AdminSubscribers)} />
            <Route path="/admin/contact" element={Protected(AdminContactInbox)} />
            <Route path="/admin/payments" element={Protected(AdminCustomPayments)} />
            <Route path="/admin/audit" element={Protected(AdminAudit)} />
            <Route path="/admin/settings" element={Protected(AdminSettings)} />

            <Route path="*" element={Public(Home)} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}

export default App;
